export enum FooterConstants {
  REQUEST_FOOTER_START = 'REQUEST_FOOTER_START',
  REQUEST_FOOTER_SUCCESS = 'REQUEST_FOOTER_SUCCESS',
  REQUEST_FOOTER_ERROR = 'REQUEST_FOOTER_ERROR',
}
